"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockVector3 = exports.mockVector2 = void 0;
const helpers_1 = require("../helpers");
const mockVector2 = (overrides) => {
    return {
        x: helpers_1.chance.floating({ min: -999, max: 999 }),
        y: helpers_1.chance.floating({ min: -999, max: 999 }),
        ...overrides,
    };
};
exports.mockVector2 = mockVector2;
const mockVector3 = (overrides) => {
    return {
        x: helpers_1.chance.floating({ min: -999, max: 999 }),
        y: helpers_1.chance.floating({ min: -999, max: 999 }),
        z: helpers_1.chance.floating({ min: -999, max: 999 }),
        ...overrides,
    };
};
exports.mockVector3 = mockVector3;
//# sourceMappingURL=mockPrimitiveData.js.map